import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: 1,
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    border: '2px solid #03A9F4'
  },
  logo: {
    height: '128px',
    marginBottom: 20,
    borderRadius: 30,
  },
  formControl: {
    margin: `${theme.spacing(2)}px 0`,
    minWidth: 400,
    maxWidth: 500,
    width: 400,
  },
  mainButton: {
    '&:hover': {
      backgroundColor: '#03A9F4',
      borderColor: '#303F9F',
    }
  }
}));
